import { render, staticRenderFns } from "./OrderItemsByAddress.vue?vue&type=template&id=361249f3&scoped=true"
import script from "./OrderItemsByAddress.vue?vue&type=script&lang=js"
export * from "./OrderItemsByAddress.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsByAddress.vue?vue&type=style&index=0&id=361249f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361249f3",
  null
  
)

export default component.exports